var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-collapse",
        {
          model: {
            value: _vm.abaAtiva,
            callback: function($$v) {
              _vm.abaAtiva = $$v
            },
            expression: "abaAtiva"
          }
        },
        [
          _c(
            "el-collapse-item",
            { attrs: { name: "0" } },
            [
              _c("template", { slot: "title" }, [
                _c("h3", [_vm._v("Listagem de Beneficiários")])
              ]),
              _vm.dadosCadastro &&
              _vm.dadosCadastro.dados &&
              _vm.dadosCadastro.dados.cadastro
                ? _c(
                    "informacoes-beneficiarios",
                    {
                      attrs: {
                        beneficiarios: _vm.beneficiariosLista,
                        cadastroOriginal: _vm.dadosCadastro.dados.cadastro,
                        canRemove: true
                      },
                      on: {
                        updateBeneficiariosLista: _vm.updateBeneficiariosLista
                      }
                    },
                    [
                      _c("template", { slot: "button-adicionar" }, [
                        _c("span", { staticStyle: { color: "red" } }, [
                          _vm._v(
                            "Obs: Lista de beneficiários só será modificada ao salvar ou finalizar análise da OS."
                          )
                        ]),
                        _c(
                          "div",
                          { staticClass: "botaoAddMembros pull-right" },
                          [
                            !_vm.isAdicionandoBeneficiario
                              ? _c("app-button", {
                                  attrs: {
                                    titulo: "Adicionar Beneficiário",
                                    tipo: "success",
                                    icone: "plus-circle",
                                    method: "novoBeneficiario"
                                  },
                                  on: { novoBeneficiario: _vm.novoBeneficiario }
                                })
                              : _vm._e()
                          ],
                          1
                        )
                      ])
                    ],
                    2
                  )
                : _vm._e()
            ],
            2
          ),
          _vm.isAdicionandoBeneficiario
            ? _c(
                "el-collapse-item",
                { attrs: { name: "1" } },
                [
                  _c("template", { slot: "title" }, [
                    _c("div", { staticClass: "titulo" }, [
                      _vm._v(
                        _vm._s(
                          _vm.isEditar
                            ? "Editar Beneficiário"
                            : "Adicionar Beneficiário"
                        )
                      )
                    ])
                  ]),
                  _c("app-pessoa-fisica", {
                    attrs: {
                      pessoa: _vm.beneficiario.pessoa,
                      conjuge: _vm.beneficiario.conjuge.pessoa,
                      isBeneficiarioTeq: true,
                      nomeAba: "Beneficiário",
                      observer: _vm.observer
                    }
                  }),
                  _c("app-documentos", {
                    attrs: {
                      aba: "Beneficiário",
                      maxSize: 25000,
                      "valid-extensions": [
                        "png",
                        "jpg",
                        "jpeg",
                        "pdf",
                        "doc",
                        "docx"
                      ],
                      observer: _vm.observer,
                      tiposDocumentos: _vm.getDocumentos,
                      tiposDocumentosObrigatorios: [],
                      removeOutros: true,
                      documentos: _vm.beneficiario.documentos
                    }
                  }),
                  _c(
                    "div",
                    { staticClass: "buttons" },
                    [
                      _c("app-button", {
                        staticClass: "botao",
                        attrs: {
                          titulo: "Cancelar",
                          tipo: "default",
                          size: "medium",
                          icone: "times-circle",
                          method: "disableAdicionar"
                        },
                        on: { disableAdicionar: _vm.disableAdicionar }
                      }),
                      _c("app-button", {
                        staticClass: "botao",
                        attrs: {
                          titulo: _vm.getTitulo(),
                          tipo: "success",
                          size: "medium",
                          icone: "plus-circle",
                          method: "adicionar"
                        },
                        on: { adicionar: _vm.adicionar }
                      })
                    ],
                    1
                  )
                ],
                2
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5e94249c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e94249c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/Beneficiarios.vue
// module id = null
// module chunks = 